"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Label/index"), exports);
//# sourceMappingURL=Label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/Label.js
// module id = 111
// module chunks = 0